'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'star-half';
var width = 576;
var height = 512;
var aliases = [61731];
var unicode = 'f089';
var svgPathData = ['M51.5 206.2l152.8-26.4 6.7-1.2 3.8-5.7L296.1 52.4l0 367.3L141.6 486l22.3-155.3L165 323l-5.5-5.6L51.5 206.2z', 'M148.1 328.5L124.4 493.4 121.7 512l17.2-7.4 173.1-74.4 0-401.6 0-28.6-16 23.7L201.6 164 38 192.3l-19.1 3.3 13.5 13.9 115.7 119zM51.5 206.2l152.8-26.4 6.7-1.2 3.8-5.7L296.1 52.4l0 367.3L141.6 486l22.3-155.3L165 323l-5.5-5.6L51.5 206.2z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStarHalf = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;